import { Mixpanel } from './Mixpanel'

export { Mixpanel }
